"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { useState } from "react";
import Play from "~/components/icons/play-eon";
import YouTubePlayer from "~/components/job-page/jobadvideo/youtube-eon";
import { useLanguage } from "~/translations/loader/use-language";
import AllJobsCtaHungary from "./all-jobs-cta-eon-hungary";
function TeaserBar() {
  const $ = _c(25);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.hungary_teaserBar_video1) {
    t0 = {
      title: t.hungary_teaserBar_video1,
      videoId: "AbgPmpxAaSs",
      thumbnail: "images/teaserbar/hungary/thumbnail_video1.webp",
      bgColor: "primary"
    };
    $[0] = t.hungary_teaserBar_video1;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t.hungary_teaserBar_video2) {
    t1 = {
      title: t.hungary_teaserBar_video2,
      videoId: "2jDKWOohrnQ",
      thumbnail: "images/teaserbar/hungary/thumbnail_video2.webp",
      bgColor: "secondary"
    };
    $[2] = t.hungary_teaserBar_video2;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t.hungary_teaserBar_video3) {
    t2 = {
      title: t.hungary_teaserBar_video3,
      videoId: "b7RaM4XLmPo",
      thumbnail: "images/teaserbar/hungary/thumbnail_video3.webp",
      bgColor: "tertiary"
    };
    $[4] = t.hungary_teaserBar_video3;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = [t0, t1, t2];
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const videos = t3;
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = index => {
      setActiveVideoIndex(index);
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleVideoChange = t4;
  let t5;
  if ($[11] !== t.hungary_teaserBar_HL) {
    t5 = <h2 className="mb-12 w-full font-bold text-3xl text-primary md:text-4xl">{t.hungary_teaserBar_HL}</h2>;
    $[11] = t.hungary_teaserBar_HL;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = videos[activeVideoIndex];
  const t7 = videos[activeVideoIndex];
  let t8;
  if ($[13] !== t6.thumbnail || $[14] !== t7.videoId) {
    t8 = <YouTubePlayer thumbnailSrc={t6.thumbnail} videoId={t7.videoId} />;
    $[13] = t6.thumbnail;
    $[14] = t7.videoId;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== activeVideoIndex || $[17] !== videos) {
    t9 = <div className="grid grid-cols-2 gap-4 lg:auto-rows-fr lg:grid-cols-1">{videos.map((video, index_0) => index_0 !== activeVideoIndex && <OtherVideo key={index_0} onVideoChange={() => handleVideoChange(index_0)} video={video} />)}</div>;
    $[16] = activeVideoIndex;
    $[17] = videos;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="grid auto-cols-[2.1fr_1fr] items-stretch gap-4 lg:grid-flow-col">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5) {
    t11 = <div className="w-full bg-gray-200 px-6 py-10 text-white md:px-10 md:py-20" id="videos"><div className="mx-auto max-w-screen-xl">{t5}{t10}</div></div>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
interface videoProps {
  onVideoChange: () => void;
  video: {
    videoId: string;
    thumbnail: string;
    title: string;
    bgColor?: string;
  };
}
export default function TeaserBarEonHungary() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><TeaserBar /><AllJobsCtaHungary /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function OtherVideo(t0) {
  const $ = _c(6);
  const {
    video,
    onVideoChange
  } = t0;
  let t1;
  if ($[0] !== video.thumbnail) {
    t1 = <CustomImage className="object-cover" fill={true} src={video.thumbnail} />;
    $[0] = video.thumbnail;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute top-1/2 left-1/2 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-2xl bg-white text-clientFont opacity-50 transition-all duration-300 group-hover:opacity-100"><Play className="translate-x-px fill-gray-500 text-gray-500" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onVideoChange || $[4] !== t1) {
    t3 = <button className="group relative block aspect-video cursor-pointer transition-all duration-300 hover:scale-[1.02] lg:aspect-auto" onClick={onVideoChange} type="button">{t1}{t2}</button>;
    $[3] = onVideoChange;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}